import React from 'react';
import { Box, ButtonBase, FormControlLabel, Radio, Typography, useTheme } from '@mui/material';

type LevelRadioButtonProps = {
  value: string;
  active?: boolean;
  title: string;
  subtitle: string;
  description: string | React.ReactNode;
  onClick?: (value: string) => void;
};

export const LevelRadioButton = ({
  value,
  active = false,
  title,
  subtitle,
  description,
  onClick = () => {},
}: LevelRadioButtonProps) => {
  const theme = useTheme();
  return (
    <ButtonBase
      sx={{
        textAlign: 'left',
        bgcolor: active ? `${theme.palette.primary.light}24` : 'unset',
        border: '1px solid transparent',
        '&:hover': {
          border: `1px solid ${theme.palette.primary.light}`,
        },
        borderRadius: 1,
      }}
      component="div"
    >
      <FormControlLabel
        control={<Radio value={value} />}
        label={
          <Box sx={{ marginLeft: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>

            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
              {subtitle}
            </Typography>

            <Typography color="textSecondary" sx={{ fontSize: 12, marginTop: 0.5 }} component="div">
              {description}
            </Typography>
          </Box>
        }
        sx={{ width: '100%', alignItems: 'flex-start', paddingX: 2, paddingY: 1.5 }}
        onClick={() => onClick(value)}
      />
    </ButtonBase>
  );
};
